import { useMemo } from 'react';
import { useRouter } from './useCustomRouter';

const useIsNativeView = () => {
  const router = useRouter();

  const isNativeView = useMemo(() => {
    let isNative = false;

    try {
      const query = router?.query?.mobileApp;
      const alternativeQuery = router?.query?.mobileapp;
      if (
        (query !== undefined && query !== null && query === 'true') ||
        (alternativeQuery !== undefined && alternativeQuery !== null && alternativeQuery === 'true')
      ) {
        isNative = true;
      }
    } catch (error) {
      console.error('Error parsing mobileApp query:', error);
    }

    return isNative;
  }, [router?.query?.mobileApp, router?.query?.mobileapp]);

  return isNativeView;
};

export default useIsNativeView;
